
import { defineComponent } from 'vue'
import * as echarts from 'echarts'
import tabCapsule from '../components/tab-capsule.vue'
import popupRecharge from '../components/popup-recharge.vue'
import user from '../utils/user'
import { ElMessage } from 'element-plus'
import sunny from '../components/dialog/sunny.vue'
import { getUserInfo, getqueryreceiptaccountapi, getsaasCompanyinfoapi } from '../api/base'
import { getMoneyTrend, PlanStatisticsDto, addLongTermRecharge, periodRechargeListExport } from '../api/long-insure'
import { queryStatisticsApi, insureEnsurePlanApi, queryInsureCompanyRateStatus } from '../api/long-insure-new'
import { wxUuid } from '../utils/util'
import dayjs from 'dayjs'

export default defineComponent({
  name: 'LongInsure',
  components: {
    tabCapsule,
    popupRecharge,
    sunny
  },
  data() {
    return {
      listone: [],
      listtwo: [],
      maxone: 0,
      maxtwo: 0,
      total1: 0,
      total2: 0,
      showtcflag: true,
      accountBalance: '',
      allEnsureCount: '',
      companyPlans: [] as any,
      isDeletePopup: false,
      peopleStatistics: {} as PlanStatisticsDto,
      statisticsTab: 0,
      peopleStatisticsType: 0,
      isTrendEmpty: false,
      isRecharge: false,
      openBank: '',
      bankNo: '',
      bankName: '',
      showSunnyDialog: false,
      user: user,
      activeName: 'OK',
      okPlanList: [] as any,
      noPlanList: [] as any,
      showInsureRate: false,
      increaseData: {} as any,
      showRiseUp: false
    }
  },
  async created() {
    const hideRateRiseDate = localStorage.getItem('periodRateRise') ? Number(localStorage.getItem('periodRateRise')) : 0
    const startOfDay = dayjs().startOf('day').valueOf()
    const endOfDay = dayjs().endOf('day').valueOf()

    console.log(hideRateRiseDate, startOfDay, endOfDay)

    // if (!hideRateRiseDate || hideRateRiseDate < startOfDay || hideRateRiseDate > endOfDay) {
    //     this.showRiseUp = true
    // }

    this.initShowInsureRate()
    // const data = await getUserInfo()
    const data: any = await getqueryreceiptaccountapi({ productType: 3 })
    console.log(data, '117843256398567348')
    this.openBank = data.openBank
    this.bankNo = data.bankNo
    this.bankName = data.bankName
    this.getInsureData()
    // this.getMoneyTrend()
    this.onPeopleStatisticsType()
    if (sessionStorage.getItem('tcflag') === 'true') {
      this.showtcflag = true
    } else {
      this.showtcflag = false
    }
  },
  methods: {
    onInsureRateClose() {
      const curStamp = dayjs().valueOf()
      localStorage.setItem('insureRatePopDate', curStamp.toString())
      if (this.isInMorning(curStamp)) {
        localStorage.setItem('isCloseMorningInsureRate', 'true')
      }
      if (this.isInAfternoon(curStamp)) {
        localStorage.setItem('isCloseAfternoonInsureRate', 'true')
      }
      this.showInsureRate = false
    },
    isInMorning(dateStamp) {
      const limitTime = {
        morningStart: dayjs().hour(9).startOf('hour').valueOf(),
        morningEnd: dayjs().hour(11).endOf('hour').valueOf()
      }
      return dateStamp > limitTime.morningStart && dateStamp < limitTime.morningEnd
    },
    isInAfternoon(dateStamp) {
      const limitTime = {
        afternoonStart: dayjs().hour(12).startOf('hour').valueOf(),
        afternoonEnd: dayjs().hour(23).endOf('hour').valueOf()
      }
      return dateStamp > limitTime.afternoonStart && dateStamp < limitTime.afternoonEnd
    },
    async initShowInsureRate() {
      const res = await queryInsureCompanyRateStatus({ productType: 2 })
      if (!res.showToastWindow) return
      this.increaseData = res
      const peirodIncreaseRate = localStorage.getItem('peirodIncreaseRate')
      const insureCloseData = localStorage.getItem('insureRatePopDate')
      const isCloseMorningInsureRate = localStorage.getItem('isCloseMorningInsureRate')
      const isCloseAfternoonInsureRate = localStorage.getItem('isCloseAfternoonInsureRate')
      const curDate = dayjs().valueOf()

      if (!insureCloseData) {
        this.showInsureRate = true
      } else {
        const closeDateEndTime = dayjs(Number(insureCloseData)).endOf('day').valueOf()
        // 跨天清空标记
        if (curDate > closeDateEndTime) {
          localStorage.setItem('isCloseMorningInsureRate', 'false')
          localStorage.setItem('isCloseAfternoonInsureRate', 'false')
        }
        // 同一天涨幅变动了，重新弹出提示框
        if (peirodIncreaseRate !== 'undefined' && res.increaseRate !== Number(peirodIncreaseRate)) {
          this.showInsureRate = true
          localStorage.setItem('peirodIncreaseRate', res.increaseRate)
          return
        }
        // 上午时段或是下午时段且未点过（首次） 弹出提示框
        if ((this.isInMorning(curDate) && isCloseMorningInsureRate === 'false') || (this.isInAfternoon(curDate) && isCloseAfternoonInsureRate === 'false')) {
          this.showInsureRate = true
        }
      }
    },
    toInsureDetail(id: number) {
      this.$router.push({
        path: '/long-insure/detail/' + id
      })
    },
    closetc() {
      this.showtcflag = false
      sessionStorage.setItem('tcflag', 'true')
    },
    // 添加
    onLinkToInsureCompany() {
      this.$router.push({
        path: '/insure-daily-plan',
        query: {
          insureType: 2
        }
      })
    },
    longcz() {
      if (this.accountBalance === null) {
        ElMessage({
          type: 'warning',
          message: '温馨提示：您还没有开通该功能权限，如有需要请联系销售'
        })
      } else {
        this.isRecharge = true
      }
    },
    async getInsureData() {
      const result = await insureEnsurePlanApi({
        insureType: 2
      })
      result?.ensurePlanList?.forEach((ele: any) => {
        if (ele.insurePlanType === 1) {
          ele.type = 4
        } else {
          if (ele.effectType === 1) {
            ele.type = 3
          }
          if (ele.effectType === 2) {
            ele.type = 5
          }
        }
      })
      console.log(result, 'ghuaugyhsgdhuyhugs')

      this.companyPlans = result.ensurePlanList
      this.accountBalance = result.balance
      this.allEnsureCount = result.allEnsureCount

      result?.ensurePlanList?.forEach((_: any) => {
        if (!_.enable && !_.ensureCount) {
          this.noPlanList.push({
            ..._,
            allowOperateTime: this.onDealRuleTime(_.allowOperateTime)
          })
        }

        if (_.enable || _.ensureCount) {
          this.okPlanList.push({
            ..._,
            allowOperateTime: this.onDealRuleTime(_.allowOperateTime)
          })
        }
      })

      const hasYg = this.companyPlans?.some((i: any) => i.code === 'period_003_yg')
      if (hasYg && !localStorage.getItem('sunnyNoticeClose')) {
        this.showSunnyDialog = true
      }
    },

    onDealRuleTime(time) {
      if (time) {
        const arr = time.split(':')
        arr.length = 2
        return arr.join(':')
      } else {
        return '00:00'
      }
    },
    async onPeopleStatisticsType() {
      await this.getPeopleStatistics()
      this.onPeopleStatisticsTab(this.statisticsTab)
    },
    async getPeopleStatistics() {
      this.total1 = 0
      this.total2 = 0
      let res: any = await queryStatisticsApi({
        policyStatus: this.peopleStatisticsType ? '1' : ''
      })
      console.log(res, 'gsuighiudsghuisuhi')
      let max1 = 0
      let max2 = 0
      if (res.occupationGroup.length !== 0) {
        res.occupationGroup.forEach((ele: any, i: number) => {
          this.total1 += ele.count
          if (max1 < ele.count) {
            max1 = ele.count
          }
        })
      }
      if (res.serveCompanyGroup.length !== 0) {
        res.serveCompanyGroup.forEach((ele: any, i: number) => {
          this.total2 += ele.count
          if (max2 < ele.count) {
            max2 = ele.count
          }
        })
      }
      this.maxone = max1
      this.maxtwo = max2
      this.listone = res.occupationGroup
      this.listtwo = res.serveCompanyGroup
      this.peopleStatistics = res
    },
    onPeopleStatisticsTab(tab: number) {
      this.statisticsTab = tab
      const element = document.getElementById('people-statistics') as HTMLElement
      echarts.dispose(element)
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b} <br/>{c}人  ({d}%)'
        },
        series: [
          {
            type: 'pie',
            radius: ['60%', '80%'],

            label: {
              position: 'inner',
              formatter: '{b} {c}人'
            },
            data: [] as { value: number; name: string }[]
          }
        ]
      }
      const charts = echarts.init(element)
      if (tab === 0) {
        option.series[0].data = this.peopleStatistics.occupationGroup.map((item) => ({
          value: item.count,
          name: item.occupationName
        }))
      } else {
        option.series[0].data = this.peopleStatistics.serveCompanyGroup.map((item) => ({
          value: item.count,
          name: item.serveCompanyName
        }))
      }
      charts.setOption(option)
    },
    async getMoneyTrend() {
      const statistics = await getMoneyTrend()
      console.log(statistics, 'statistics')
      if (statistics?.length === 0) {
        this.isTrendEmpty = true
        return
      }
      console.log('打印啦吗')
      setTimeout(() => {
        const element = document.getElementById('trend') as HTMLElement
        console.log(element, 'element')
        echarts.dispose(element)
        const option = {
          xAxis: {
            type: 'category',
            data: statistics.map((item) => item.ensureDay)
          },
          yAxis: {
            type: 'value'
          },
          grid: {
            left: '30px',
            right: '30px',
            top: '30px',
            bottom: '30px'
          },
          series: [
            {
              name: '人数',
              data: statistics.map((item) => item.peopleCount),
              type: 'bar'
            },
            {
              name: '金额',
              data: statistics.map((item) => item.money),
              type: 'bar'
            }
          ]
        }
        console.log(option, 'option')
        const charts = echarts.init(element)
        charts.setOption(option)
        this.isTrendEmpty = false
      }, 300)
    },
    // 充值弹窗点击确定关闭
    async onDetermine(num: string, ocrNum: string, ocrImg: string, isRepeat: boolean) {
      if (!num) {
        this.$message.error('请输入金额')
        return
      }
      if (!ocrImg) {
        this.$message.error('请上传凭证')
        return
      }
      const result = await addLongTermRecharge({
        rechargeAmount: num,
        ocrAmount: ocrNum,
        voucherUrl: ocrImg,
        receiptId: user.receiptId,
        isRepeat: isRepeat,
        requestId: wxUuid()
      })
      console.log('result', result)
      if (result) {
        this.$message.success('提交成功')

        if (result.msg === '审核中') {
          this.$refs.rechargeRef.typeIndex = 0
        } else if (result.msg === '薪福通快速审核通过') {
          this.$refs.rechargeRef.typeIndex = 1
        }
        console.log(2121, this.$refs.rechargeRef.typeIndex)
        // this.isRecharge = false
      }
    },
    onRateRiseClose() {
      this.showRiseUp = false
      localStorage.setItem('periodRateRise', dayjs().valueOf().toString())
    }
  }
})
